import { axiosHttpClient } from "../axios";
import handleStatusCases from "../handle-status-cases";

const { REACT_APP_BASE_URL } = process.env;

export type TDuplicateBudgetBody = {
    name: string;
    color: string;
    secondaryColor: string;
    description: string;
    clientId: string;
    budgetTypeId: string;
    duplicateEstimation: boolean;
};

export type TDuplicateBudget = {
    userId: string;
    budgetId: string;
    body: TDuplicateBudgetBody;
};

export type TDuplicateBudgetResponse = {
    data: {
        id_e: string;
    };
};

export default async ({
    body: bodyReq,
    budgetId,
    userId,
}: TDuplicateBudget): Promise<TDuplicateBudgetResponse> => {
    const tempHeaders = {
        auth: true,
        "x-user-id": userId,
    };

    const httpRequest = await axiosHttpClient({
        url: `${REACT_APP_BASE_URL}/budget/${budgetId}/duplicate`,
        method: "POST",
        body: bodyReq,
        headers: tempHeaders,
    });
    const { body, statusCode } = httpRequest;

    return handleStatusCases<TDuplicateBudgetResponse>({ body, statusCode });
};
